/* eslint-disable import/prefer-default-export */
import fetcher from '@api/fetchers/simpleFetcher';
import { HOST_TYPE, getHost } from '@utils/api-helper/host';

const defaultHost = getHost();
const backendHost = getHost(HOST_TYPE.BACKEND_API_HOST);

export const fetchPreviewDetails = async (
  courseUID,
  previewUid,
  authorization
) => {
  return fetcher(
    `${defaultHost}v1/uplus/moderator/programme/${courseUID}/video_preview?video_uid=${previewUid}`,
    { authorization }
  );
};

// If plus_included=true is passed in this API then response will have for_plus info of programme also in the response
export const fetchClassDetails = (
  classUID,
  authorization,
  plusIncluded = false
) =>
  fetcher(
    `${backendHost}v1/uplus/classes/${classUID}/details/${
      plusIncluded ? '?plus_included=true' : ''
    }`,
    { authorization }
  );

export const fetchSimilarAndOtherCourses = (classUID, authorization) =>
  fetcher(`${defaultHost}v1/search_v3/special_classes/${classUID}/v2/`, {
    authorization
  });

export const fetchSimilarTopicPractice = (topicUID, authorization) =>
  fetcher(
    `${defaultHost}v2/quizzes/similar-topic-practice/?parent_uid=${topicUID}&language=0`,
    { authorization }
  );

export const getClassInfoV2 = (
  classUID,
  goalUID,
  isSyllabusFeed = false,
  authorization
) =>
  fetcher(
    `${defaultHost}v1/uplus/classes/${classUID}/info_v2/?${
      isSyllabusFeed ? 'feed=syllabus_feed&' : ''
    }goal_uid=${goalUID}`,
    {
      authorization,
      headers: {
        'X-Direct-To': 'sheldon',
        'X-PAGE': 'CLX'
      }
    }
  );

export const fetchPreviewVideoDetails = async (
  previewUid,
  authorization,
  goalUid
) => {
  return fetcher(
    `${defaultHost}v1/uplus/moderator/programme/video_preview?video_uid=${previewUid}&goal_uid=${
      goalUid || ''
    }`,
    { authorization }
  );
};

export const fetchClassesBySubjects = async (goalUid, topicUid) => {
  return fetcher(
    `${defaultHost}v1/uplus/${goalUid}/special_classes/?subject=${topicUid}`
  );
};
